import { useAccessStatus } from '../hooks/useAccessStatus';
import AccessPendingScreen from './AccessPendingScreen';
import TrialEndedScreen from './TrialEndedScreen';

const fill = {
  height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  flexDirection: 'column', gap: '14px', background: 'var(--bg)',
  fontFamily: 'var(--font-mono)', fontSize: '13px', color: 'var(--text-muted)',
  textAlign: 'center', padding: '24px',
};

// Gates the chat app behind access status. Assumes the user is already authenticated
// (wrap it inside <ProtectedRoute>). Developers in allowed_users pass through immediately;
// everyone else sees the "account being reviewed" screen until an admin admits them or
// flips the chat_enabled switch.
export default function LaunchGate({ children }) {
  const { loading, error, canUseChat, mustSubscribe, subscribeReason, syncing, refetch, recheck } = useAccessStatus();

  if (loading) {
    return <div style={fill}>Checking your access…</div>;
  }

  if (error) {
    return (
      <div style={fill}>
        <span>We couldn’t verify your access just now.</span>
        <button
          onClick={refetch}
          style={{
            border: '1px solid var(--border-bright)', background: 'transparent',
            color: 'var(--text-primary)', borderRadius: '8px', padding: '8px 16px',
            fontFamily: 'var(--font-display)', fontSize: '13px', cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  if (canUseChat) return children;

  // Trial expired with no active subscription → paywall. (Checked before the pending screen
  // so an expired member sees "choose a plan", not "your account is being reviewed".)
  if (mustSubscribe) return <TrialEndedScreen reason={subscribeReason} onRecheck={recheck} syncing={syncing} />;

  return <AccessPendingScreen onEnter={refetch} />;
}
